import type { NextPage } from 'next'
import Link from 'next/link'

import Title from '~/components/global/CTitle'
import { DefaultLayout } from '~/components/layout/Default'

const Music: NextPage = () => {
    return (
        <DefaultLayout pageTitle={'楽曲情報'}>
            <div className="mt-12 md:mt-14 max-w-6xl w-[90vw] mx-auto">
                <Title src="/images/title/music.svg" title={'楽曲情報'} subtitle />
                <div className="md:flex lg:pb-16">
                    <div className="py-8 md:py-16 px-4 lg:px-22 md:px-12 md:mr-6 bg-[#ffff00b3] mt-10">
                        <div className="text-center border-t border-b border-c-secondary p-6">
                            <p className="text-c-primary font-bold">第二期オープニングテーマ</p>
                            <h2 className="text-2xl font-RocknRoll">「BE the HERO」</h2>
                            <div className="w-52 h-2 mx-auto -mt-[8px]  bg-c-secondary" />
                            <p className="text-lg mt-2 font-RocknRoll">Raon</p>
                        </div>
                        <div className="mx-auto mt-8 flex justify-center">
                            <img src="/images/music/cd-be_the_hero.jpg" alt="BE the HERO" />
                        </div>
                        <div className="text-c-primary text-center md:mt-12 mt-8 font-RocknRoll md:text-3xl text-xl">
                            <Link href={'/music/opening2'}>MORE &gt;</Link>
                        </div>
                    </div>

                    <div className="py-8 md:py-16 px-4 lg:px-22 md:px-12 md:ml-6 bg-[#ffff00b3] mt-10">
                        <div className="text-center border-t border-b border-c-secondary p-6">
                            <p className="text-c-primary font-bold">第二期エンディングテーマ</p>
                            <h2 className="text-2xl font-RocknRoll">「ZERO」</h2>
                            <div className="w-28 h-2 m-auto -mt-[8px] bg-c-secondary" />
                            <p className="text-lg mt-2 font-RocknRoll">Sano ibuki</p>
                        </div>
                        <div className="mx-auto mt-8 flex justify-center">
                            <img src="/images/music/cd-zero.jpg" alt="ZERO" />
                        </div>
                        <div className="text-c-primary text-center md:mt-12 mt-8 font-RocknRoll md:text-3xl text-xl">
                            <Link href={'/music/ending2'}>MORE &gt;</Link>
                        </div>
                    </div>
                </div>

                <div className="md:flex lg:pb-32">
                    <div className="py-8 md:py-16 px-4 lg:px-22 md:px-12 md:mr-6 bg-[#ffff00b3] mt-10">
                        <div className="text-center border-t border-b border-c-secondary p-6">
                            <p className="text-c-primary font-bold">第一期オープニングテーマ</p>
                            <h2 className="text-2xl font-RocknRoll">「暁光」</h2>
                            <div className="w-24 h-2 mx-auto -mt-[8px]  bg-c-secondary" />
                            <p className="text-lg mt-2 font-RocknRoll">Half time Old</p>
                        </div>
                        <div className="mx-auto mt-8 flex justify-center">
                            <img src="/images/music/cd-half_time_old.png" alt="暁光" />
                        </div>
                        <div className="text-c-primary text-center md:mt-12 mt-8 font-RocknRoll md:text-3xl text-xl">
                            <Link href={'/music/opening'}>MORE &gt;</Link>
                        </div>
                    </div>

                    <div className="py-8 md:py-16 px-4 lg:px-22 md:px-12 md:ml-6 bg-[#ffff00b3] mt-10">
                        <div className="text-center border-t border-b border-c-secondary p-6">
                            <p className="text-c-primary font-bold">第一期エンディングテーマ</p>
                            <h2 className="text-2xl font-RocknRoll">「Reflexion」</h2>
                            <div className="w-40 h-2 m-auto -mt-[8px] bg-c-secondary" />
                            <p className="text-lg mt-2 font-RocknRoll">SpendyMily</p>
                        </div>
                        <div className="mx-auto mt-8 flex justify-center">
                            <img src="/images/music/cd-reflexion.png" alt="Reflexion" />
                        </div>
                        <div className="text-c-primary text-center md:mt-12 mt-8 font-RocknRoll md:text-3xl text-xl">
                            <Link href={'/music/ending'}>MORE &gt;</Link>
                        </div>
                    </div>
                </div>
            </div>
        </DefaultLayout>
    )
}

export default Music
